module.exports = __webpack_public_path__ + "assets/normal/images/share4.307a08c3.png";